import { render } from "./AnimalDetail.vue?vue&type=template&id=bccf44fe&scoped=true"
import script from "./AnimalDetail.vue?vue&type=script&lang=js"
export * from "./AnimalDetail.vue?vue&type=script&lang=js"

import "./AnimalDetail.vue?vue&type=style&index=0&id=bccf44fe&lang=css"
import "./AnimalDetail.vue?vue&type=style&index=1&id=bccf44fe&lang=css"
import "./AnimalDetail.vue?vue&type=style&index=2&id=bccf44fe&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bccf44fe"]])

export default __exports__